import { render, staticRenderFns } from "./znxq.vue?vue&type=template&id=2424fcc3&scoped=true&"
import script from "./znxq.vue?vue&type=script&lang=js&"
export * from "./znxq.vue?vue&type=script&lang=js&"
import style0 from "./znxq.vue?vue&type=style&index=0&id=2424fcc3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2424fcc3",
  null
  
)

export default component.exports